<template>
	<el-dialog :visible.sync="openStatus" class="modify-specification-container" :title="$t('nat.text.adjustSpecification')"
		size="default" :close-on-click-modal="false" @close="doClose()">
		<el-form label-width="80px" class="ml20">
			<el-form-item :label="$t('orderConfirm.text.currentConfig') | withColon">
				<el-table :data="[detailData]" style="margin-bottom:20px;">
					<!--名字-->
					<el-table-column property="name" :label="$t('nat.text.name')" min-width="100">
						<p style="margin-bottom:0px">{{ detailData.name | maybeEmpty }}</p>
					</el-table-column>
					<!--到期时间-->
					<el-table-column v-if="detailData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION"
						property="expire_date" :label="$t('listPage.tableLabel.expireTime')" min-width="130">
						<span>{{ detailData.charge.chargeExpiredTime | maybeEmpty }}</span>
					</el-table-column>
					<!--当前规格-->
					<el-table-column property="current_bandwidth" :label="$t('nat.text.currentSpecification')"
						min-width="240">
						<span>{{ SpecificationTypeParams[detailData.natGatewayType] }}</span>
						<p>{{ $t('nat.text.choosedSpecification', [SpecTypeParamsDicts[detailData.natGatewayType]]) }}</p>
					</el-table-column>
					<!--计费方式-->
					<el-table-column property="charge" :label="$t('listPage.tableLabel.billMethods')" min-width="80">
						<span>{{ transformCharge(detailData.charge.chargeMode) }}</span>
					</el-table-column>
				</el-table>
			</el-form-item>
		</el-form>
		<el-form class="ml20">
			<!-- 可调整规格 -->
			<el-form-item :label="$t('nat.text.selectSpecification') | withColon" style="margin-bottom:20px">
				<el-radio-group v-model="specificationStandard" style="margin-left:10px">
					<el-radio-button v-for="(item, index) in specifications" :label="item.value" :key="index">{{ item.label
					}}</el-radio-button>
				</el-radio-group>
				<el-tooltip effect="dark" class="ml10" placement="right">
					<div slot="content" class="my-os-disk-tip">{{ $t('nat.speechCraft.natTypeTip') }}
					</div>
					<a><i class="jc-icon-question"></i></a>
				</el-tooltip>
				<p style="margin-left:80px; margin-top:10px">{{ $t('nat.speechCraft.maxLinkTip') }}</p>
				<p style="margin-left:80px;">{{ $t('nat.speechCraft.maxNewTip') }}</p>
			</el-form-item>
			<!-- 费用/小时  -->
			<el-form-item class="postpaid-price" :label="$t('listPage.text.cost') | withColon"
				v-if="(detailData.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION)">
				<div class="ml5">
					<span class="remind" v-if="hasDiscount">{{ $t('eip.text.feePerHours', [totalDiscount]) }}</span>
					<span class="remind" v-else>{{ $t('eip.text.feePerHours', [totalFee]) }}</span>
					<p>{{ $t('create.text.configureMonthPay', [totalFeePerMonth]) }}</p>
				</div>
				<div v-if="hasDiscount">
					<span class="price original-total-price">{{ $t('eip.text.originalPrice', [totalPrice]) }}</span>
					<span class="discounted-total-price">{{ $t('eip.text.discountedPrice', [totalPrice]) }}</span>
				</div>
			</el-form-item>
			<!-- 包年包月降配 -->
			<el-form-item :label="$t('listPage.text.deploymentRefundFee') | withColon"
				v-if="(detailData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) && processType === 9">
				<span class="remind">{{ $t('listPage.text.currencySymbol') }}{{ refundTotalPrice }}</span>
			</el-form-item>
			<!-- 包年包月升配 -->
			<el-form-item :label="$t('listPage.text.deploymentSupplementFee') | withColon"
				v-if="(detailData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) && processType === 1">
				<span class="remind" v-if="hasDiscount">{{ $t('listPage.text.currencySymbol') }}{{ totalDiscount }}</span>
				<span class="remind" v-else>{{ $t('listPage.text.currencySymbol') }}{{ totalFee }}</span>
				<div v-if="hasDiscount">
					<span class="price original-total-price">{{ $t('eip.text.originalPrice', [totalPrice]) }}</span>
					<span class="discounted-total-price">{{ $t('eip.text.discountedPrice', [totalPrice]) }}</span>
				</div>
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="doClose">{{ $t('listPage.text.cancelButton') }}</el-button>
			<el-button type="primary" @click="doConfirm()">
				{{ $t('listPage.text.sureButton') }}
			</el-button>
		</span>
	</el-dialog>
</template>


<script>

import {
	ChargeModeMap,
	CreateTypeConstant,
	ChargeModeConstant,
	SpecificationTypes,
	SpecificationTypeSnatMax,
	SpecTypeParamsDicts,
	SpecificationTypeParams,
	SpecTypeParamsDict
} from '@/common/Constants';
import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';

export default {
	data() {
		return {
			specificationStandard: '',
			specifications: SpecificationTypes,
			largerThan: false,
			openStatus: false,
			totalFee: 0.00,
			totalFeePerMonth: 0,
			totalDiscount: 0.00,
			totalPrice: 0.00,
			expirationDate: '',
			refundTotalPrice: '',
			// 变配明细 1-升配补差价，2-降配延时，3-临时升配，9-降配退款
			processType: '',
      favorablePricePerHour: '', // 省 = 原价 - 应付
		};
	},
	computed: {
		// 是否有折扣
		hasDiscount() {
			return this.totalDiscount !== '0.00' && this.totalDiscount !== '0'
				&& this.totalDiscount !== 0;
		},
		ChargeModeMap: () => ChargeModeMap,
		CreateTypeConstant: () => CreateTypeConstant,
		ChargeModeConstant: () => ChargeModeConstant,
		SpecificationTypes: () => SpecificationTypes,
		SpecificationTypeSnatMax: () => SpecificationTypeSnatMax,
		specificationTypeDicts: () => specificationTypeDicts,
		SpecificationTypeParams: () => SpecificationTypeParams,
		SpecTypeParamsDicts: () => SpecTypeParamsDicts,
		SpecTypeParamsDict: () => SpecTypeParamsDict,
	},
	props: {
		dialogVisible: {
			type: Boolean,
			default: true,
		},
		detailData: {
			type: Object,
		}
	},
	watch: {
		dialogVisible(val) {
			if (val) {
				this.specificationStandard = this.detailData.natGatewayType;
				this.calPrice()
			}
			this.openStatus = val;


		},
		specificationStandard(value) {
			this.calPrice()
		},

	},
	methods: {
		// 关闭弹框
		doClose() {
			this.resetInitParams();
			this.$emit('ifDialogVisible', false);
		},
		// 点击确认按钮，修改弹性公网IP
		doConfirm() {
			this.createTempOrder();
		},
		resetInitParams() {
			this.totalFee = 0.00;
			this.totalDiscount = 0.00;
			this.totalPrice = 0.00;
		},
		calPrice() {
			const gridData = this.detailData;
			const params = {
				cmd: 3,
				region: gridData.region,
				timeUnit: 3,
				timeSpan: 12,
				count: 1,
				resourceId: gridData.natGatewayId,
				createType: CreateTypeConstant.NAT,
				deviceType: this.specificationStandard,
				billingType: gridData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : 1
			};
			let calPriceUrl = '';
			if (gridData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
				calPriceUrl = "/api/price/billingprice/calculateTotalPrice";
			} else if (gridData.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION) {
				calPriceUrl = "/api/price/calculateTotalPrice";
			}
			Ajax.get(calPriceUrl, params)
				.then((res) => {
          const { discountedTotalPrice, totalPrice, totalDiscount, refundTotalPrice, list } = res?.data || {};
					this.totalFee = changeTwoDecimal(discountedTotalPrice);
					this.totalPrice = changeTwoDecimal(totalPrice);
					this.totalDiscount = changeTwoDecimal(totalDiscount);
					this.expirationDate = list && list[0]?.endTime;
					this.refundTotalPrice = changeTwoDecimal(refundTotalPrice);
					this.totalFeePerMonth = changeTwoDecimal(mulDecimals(mulDecimals(this.totalFee, 24), 30));
					this.processType = list && list[0]?.processType;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		transformCharge(payMethod) {
			switch (payMethod) {
				case 'prepaid_by_duration':
					return this.$t('privateNetInstance.monthAndYear');
				case 'postpaid_by_duration':
					return this.$t('create.text.byConfigurations');
				default:
					return '';
			}
		},
		createTempOrder() {
			const param = {
				region: this.detailData.region, // 区域
				clientToken: Normal.getClientToken(), // 用于保证请求的幂等性，唯一
				resourceId: this.detailData.natGatewayId,
				natGatewayType: this.specificationStandard,
				chargeMode: this.detailData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : 1,
				orderType: 3,
			};
			Ajax.post('/api/cps/nat/modifySpec', param)
				.then((res) => {
					const orderId = res.data.tempOrderNumber;
					if (orderId !== '' && orderId !== undefined) {
						window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
	}
};
</script>

<style lang="scss">
.modify-specification-container {
	.postpaid-price {
		display: flex;
	}

	.remind {
		color: #FF0000;
		font-size: 12px
	}

	.ml5 {
		margin-left: 5px;
	}

	.mt6 {
		margin-top: 6px;
		display: inline-block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/nat/ModifySpecification.vue